/**
 * ローカルストレージのユーティリティ関数
 */

/**
 * ローカルストレージにboolean値を保存
 * @param key ストレージキー
 * @param value 保存する値
 */
export const setBoolean = (key: string, value: boolean): void => {
  localStorage.setItem(key, String(value));
};

/**
 * ローカルストレージからboolean値を取得
 * @param key ストレージキー
 * @returns 保存されている値、存在しない場合はfalse
 */
export const getBoolean = (key: string): boolean => {
  return localStorage.getItem(key) === 'true';
};

/**
 * ローカルストレージに文字列を保存
 * @param key ストレージキー
 * @param value 保存する値
 */
export const setString = (key: string, value: string): void => {
  localStorage.setItem(key, value);
};

/**
 * ローカルストレージから文字列を取得
 * @param key ストレージキー
 * @returns 保存されている値、存在しない場合はnull
 */
export const getString = (key: string): string | null => {
  return localStorage.getItem(key);
};

/**
 * ローカルストレージから削除
 * @param key ストレージキー
 */
export const remove = (key: string): void => {
  localStorage.removeItem(key);
};

/**
 * ローカルストレージを全て削除
 */
export const clearAll = (): void => {
  localStorage.clear();
};
